import { Layout, Menu, Drawer, Grid } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  ShoppingOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import { getUser } from "../utils/auth";
import CustomerHeader from "./CustomerHeader";

const { useBreakpoint } = Grid;
const { Header, Sider, Content } = Layout;
export default function AppLayout({ children }) {
  const navigate = useNavigate();
  const user = getUser();
  const screens = useBreakpoint();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isMobile = !screens.md; // below 768px
  const menus = {
    admin: [
      {
        key: "/admin/dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
      },
      { key: "/admin/users", icon: <TeamOutlined />, label: "Users" },
      { key: "/my-orders", icon: <ShoppingOutlined />, label: "Orders" },
      { key: "/admin/products", icon: <ShoppingOutlined />, label: "Products" },
      {
        key: "/admin/bulk-products",
        icon: <ShoppingOutlined />,
        label: "Bulk Products",
      },
      {
        key: "/admin/categories",
        icon: <ShoppingOutlined />,
        label: "Categories",
      },
      { key: "/admin/catalog", icon: <ShoppingOutlined />, label: "Catalogs" },
      {
        key: "/admin/subcategory-color-images",
        icon: <ShoppingOutlined />,
        label: "Color-Image Map",
      },
      {
        key: "/admin/attributes",
        icon: <ShoppingOutlined />,
        label: "Set Variants",
      },
    ],
    manager: [
      { key: "/admin/users", icon: <TeamOutlined />, label: "Users" },
      { key: "/my-orders", label: "Orders" },
      // { key: "/admin/products", label: "Products" },
    ],
    employee: [{ key: "/my-orders", label: "My Orders" }],
  };
  const menuComponent = (
    <Menu
      theme="dark"
      mode="inline"
      items={menus[user?.role]}
      onClick={({ key }) => {
        navigate(key);
        setMobileOpen(false); // close drawer on click
      }}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* ✅ Desktop Sidebar */}
      {!isMobile && user?.role !== "customer" && (
        <Sider collapsible>
          <div style={{ padding: 10, background: "#fff" }}>
            <a href="/">
              <img
                src="/assets/images/logo-myfone.png"
                style={{ width: "100%" }}
              />
            </a>
          </div>
          {menuComponent}
        </Sider>
      )}

      {/* ✅ Mobile Drawer */}
      {isMobile && (
        <Drawer
          placement="left"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          width={260}
          styles={{
            header: {
              background: "#001529",
              color: "#fff",
            },
            body: {
              padding: 0,
              background: "#001529",
            },
          }}
          closeIcon={
            <span
              style={{
                color: "#fff",
                fontSize: 18,
              }}
            >
              ✕
            </span>
          }
        >
          {/* ✅ Customer category menu inside drawer */}
          {user?.role === "customer" && (
            <CustomerHeader
              isMobile={true}
              onCategorySelect={(data) => {
                setSelectedCategory(data);
                navigate(`/subcategories/${data.id}`);
                setMobileOpen(false);
              }}
            />
          )}

          {menuComponent}
        </Drawer>
      )}

      <Layout>
        <AppHeader
          onMenuClick={() => setMobileOpen(true)}
          isMobile={isMobile}
        />
        {/* ✅ Desktop category header */}
        {!isMobile && user?.role === "customer" && (
          <CustomerHeader
            isMobile={false}
            onCategorySelect={(data) => {
              setSelectedCategory(data);
              navigate(`/subcategories/${data.id}`);
            }}
          />
        )}
        <Content style={{ margin: isMobile ? 8 : 16 }}>{children}</Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
}
